<template>
    <div>
        <v-snackbar
          v-model="snackbar"
          top
          right
          :color=tipo
          :timeout="-1"
        >
          {{ mensaje }}

          <template v-slot:action="{ attrs }">
            <v-btn
              dark
              text
              v-bind="attrs"
              @click="setSnackbar({
                    snackbar: false,
                    tipo: null,
                    mensaje: null
              })"
            >
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'Snackbar',
        data: () => ({
          timeout: null,
          milliseconds: 4000
        }),
        watch:{
            // Lanzar timeout para cerrar automáticamente el snackbar pasados X segundos
            snackbar: function(){
              if(this.snackbar){
                this.timeout = setTimeout(this.setSnackbar, this.milliseconds, {snackbar: false, tipo: null, mensaje: null});
              }else{ 
                clearTimeout(this.timeout);
              }
            }
        },
        methods: {
            ...mapActions(['setSnackbar'])
        },
        computed: {
            ...mapState(['snackbar', 'mensaje', 'tipo'])
        },
    }
</script>